import PropTypes from 'prop-types';
import React, { useMemo, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { Card, CardBody, Container, Button, Form, FormGroup, Label, Input, Row, Col, CardHeader } from 'reactstrap';
import { Formik, Field, ErrorMessage, useFormik } from 'formik';
import * as Yup from 'yup';
import { json, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import Spinners from 'components/Common/Spinner';
import * as XLSX from 'xlsx';  // Import the xlsx library
import { checkPermissions } from 'components/Common/ChkPermissions';
import { getHistoricalCallBoardsRecordsAPIURL } from 'BaseComponentAPI/HistoricCallBoardAPI';
import CantAccessPage from 'components/Common/CantAccessPage';
import Loader from 'components/Common/Loader';
import Breadcrumbs from "../../components/Common/Breadcrumb";
import TableContainer from 'components/Common/TableContainer';
import PopupWindow from 'components/Common/PopupWindow';



const HistoricCallBoard = (props) => {
    const authUser = useSelector(state => state.Login);
    document.title = "Cockpit";
    const storedPermissions = JSON.parse(localStorage.getItem('permissions')) || {};
    const { canRead, canCreate, canChange } = checkPermissions(storedPermissions);

    const [loaderOption, setLoaderOption] = useState(false);
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');  // Set the message from passed state
    const [popupType, setPopupType] = useState('');  // Set the type from passed state

    const openPopup = (message, type) => {
        setPopupMessage(message);
        setPopupType(type);
        setIsPopupVisible(true);
    };

    const closePopup = () => {
        setIsPopupVisible(false);
    };

    const columns = useMemo(
        () => [
            {
                header: "Sr No",
                accessorKey: "seqNo",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Call Type",
                accessorKey: "callType",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Call Status",
                accessorKey: "callStatus",
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ cell }) => (cell.getValue() == 1 ? "Attended" : "Unattened"),
            },
            {
                header: "Customer Name",
                accessorKey: "customerName",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Header",
                accessorKey: "header",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Mobile Number",
                accessorKey: "customerMobile",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Call Time",
                accessorKey: "callReceivedTime",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Verifier Name",
                accessorKey: "verifierName",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Verifier TAT",
                accessorKey: "verifierTAT",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Verification Starts At",
                accessorKey: "verifierStartsAt",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Verifier Call End Time",
                accessorKey: "verifierEndAt",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Verifier Disposition",
                accessorKey: "verifierDisposition",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Remark By Verifier",
                accessorKey: "verifierRemark",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "TC Name",
                accessorKey: "tcName",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "TC TAT",
                accessorKey: "tcTAT",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "TC Starts At",
                accessorKey: "tcCallAt",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Tc Call End Time",
                accessorKey: "tcCallendAt",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Telecaller Disposition",
                accessorKey: "telecallerDisposition",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Telecaller Remark",
                accessorKey: "telecallerRemark",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Future Header",
                accessorKey: "futureHeader",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Category",
                accessorKey: "category",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Subcategory",
                accessorKey: "subCategory",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Product",
                accessorKey: "product",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Disposition",
                accessorKey: "disposition",
                enableColumnFilter: false,
                enableSorting: true,
            },
            //   {
            //     header: "Action",
            //     enableColumnFilter: false,
            //     enableSorting: true,
            //     cell: cellProps => {
            //       return (
            //         <ul className="list-unstyled hstack gap-1 mb-0">
            //           <li data-bs-toggle="tooltip" data-bs-placement="top" title="View">
            //             <Link
            //               to="/job-details"
            //               className="btn btn-sm btn-soft-primary"
            //               id={`viewtooltip-${cellProps.row.original.id}`}
            //             >
            //               <i className="mdi mdi-eye-outline" />
            //             </Link>
            //           </li>
            //           <UncontrolledTooltip
            //             placement="top"
            //             target={`viewtooltip-${cellProps.row.original.id}`}
            //           >
            //             View
            //           </UncontrolledTooltip>

            //           <li>
            //             <Link
            //               to="/createoredituser"
            //               className="btn btn-sm btn-soft-info"
            //             >
            //               <i className="mdi mdi-pencil-outline" />
            //             </Link>
            //           </li>

            //           <li>
            //             <Link
            //               to="#"
            //               className="btn btn-sm btn-soft-danger"
            //               onClick={() => {
            //                 const jobData = cellProps.row.original
            //                 onClickDelete(jobData)
            //               }}
            //               id={`deletetooltip-${cellProps.row.original.id}`}
            //             >
            //               <i className="mdi mdi-delete-outline" />
            //               <UncontrolledTooltip
            //                 placement="top"
            //                 target={`deletetooltip-${cellProps.row.original.id}`}
            //               >
            //                 Delete
            //               </UncontrolledTooltip>
            //             </Link>
            //           </li>
            //         </ul>
            //       )
            //     },
            //   },
        ],
        []
    )

    const [data, setData] = useState([]);
    const [submittedCallType, setSubmittedCallType] = useState("");
    const [pageNo, setPageNo] = useState(1);  // Track the current page number
    const [pageSize, setPageSize] = useState(50);  // Track page size
    const [totalPages, setTotalPages] = useState('');
    const [totalItems, setTotalItems] = useState('');
    const [nextPage, setNextPage] = useState('');
    const [previousPage, setPreviousPage] = useState('');
    const [currentPage, setCurrentPage] = useState('');

    const customePageSize = [50, 75, 100, 150, 200]

    const [disabelSaveBtn, setDisableSaveBtn] = useState(false);



    const today = new Date();

    // Max date = Yesterday
    const maxDate = new Date(today);
    maxDate.setDate(today.getDate() - 1);

    // Min date = 11 days before today
    const minDate = new Date(today);
    minDate.setDate(today.getDate() - 7);

    // Format YYYY-MM-DD
    const formatDate = (date) =>
    date.toISOString().split("T")[0];

    const minDateFormatted = formatDate(minDate);
    const maxDateFormatted = formatDate(maxDate);

    //Pagination
    const handlePageChange = async (newPageNo, newPageSize) => {
        if (formik.values.callType) {
            if (authUser.headers && Object.keys(authUser.headers).length > 0) {
                // console.log(`API URL: ${getNewCurrentCallBoardStatusAPIURL}?userUUID=${authUser.headers.userUUID}&callType=${formik.values.callType}&isPagination=1&pageNo=${newPageNo}&perPageRec=${newPageSize}`);

                try {
                    const response = await axios.get(
                        `${getHistoricalCallBoardsRecordsAPIURL}?userUUID=${authUser.headers.userUUID}&callType=${formik.values.callType}&isPagination=1&pageNo=${newPageNo}&perPageRec=${newPageSize}&historicDate=${formik.values.selectedDate}`,
                        {
                            headers: { ...authUser.headers },
                            'Authorization': `Bearer ${authUser.headers.access_token}`
                        }
                    );

                    if (response.data.responseMsg == "Success") {
                        // console.log(JSON.stringify(response.data))
                        setData(response.data.data.items);
                        setTotalPages(response.data.data.totalPages)
                        setTotalItems(response.data.data.totalItems);
                        setNextPage(response.data.data.nextPage);
                        setPreviousPage(response.data.data.previousPage);
                        setCurrentPage(response.data.data.currentPage);
                        setDisableSaveBtn(false);
                        setLoaderOption(false);
                    } else {
                        console.error('API Response Error:', response.data.responseMsg);
                        setLoaderOption(false);
                        setDisableSaveBtn(false);
                        openPopup(response.data.responseMsg, 'error')

                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                    setLoaderOption(false);
                    setDisableSaveBtn(false);
                    openPopup(error.message, 'error')

                }
                // finally {
                //     setLoaderOption(false);
                // }
            }
        }
    };

    const formik = useFormik({
        initialValues: {
            callType: '',
            selectedDate: maxDateFormatted
        },
        validationSchema: Yup.object({
            callType: Yup.string()
                .required('Call Type is required'),
            selectedDate: Yup.string().required('Date is required'),
        }),

        onSubmit: async (values) => {
            setLoaderOption(true);
            setDisableSaveBtn(true);
            setData([]);
            setTotalPages('');
            setPageSize(50);

            // Store the submitted call type for display in the heading
            const callTypeLabelMap = {
                "0": "All",
                "1": "Live",
                "2": "System",
                "3": "Cold",
            };
            setSubmittedCallType(callTypeLabelMap[values.callType]);

            if (authUser.headers && Object.keys(authUser.headers).length > 0) {
                console.log(`API URL: ${getHistoricalCallBoardsRecordsAPIURL}?userUUID=${authUser.headers.userUUID}&callType=${values.callType}&isPagination=1&pageNo=${pageNo}&perPageRec=${pageSize}&historicDate=${formik.values.selectedDate}`);
                console.log(pageSize);
                console.log(values.selectedDate);
                try {
                    const response = await axios.get(
                        `${getHistoricalCallBoardsRecordsAPIURL}?userUUID=${authUser.headers.userUUID}&callType=${values.callType}&isPagination=1&pageNo=${pageNo}&perPageRec=${pageSize}&historicDate=${formik.values.selectedDate}`,
                        {
                            headers: { ...authUser.headers },
                            'Authorization': `Bearer ${authUser.headers.access_token}`
                        }
                    );
                    // console.log(response.data.responseMsg)
                    if (response.data.responseMsg == "Success") {
                        // console.log(JSON.stringify(response.data))
                        setData(response.data.data.items);
                        setTotalPages(response.data.data.totalPages)
                        setTotalItems(response.data.data.totalItems);
                        setNextPage(response.data.data.nextPage);
                        setPreviousPage(response.data.data.previousPage);
                        setCurrentPage(response.data.data.currentPage);
                        setDisableSaveBtn(false);
                        setLoaderOption(false);
                    } else if (response.data.responseMsg == "Records not found") {
                        console.error('API Response Error:', response.data.responseMsg);
                        setLoaderOption(false);
                        setDisableSaveBtn(false);
                        openPopup(response.data.responseMsg, 'error')
                    }
                    else {
                        console.error('API Response Error:', response.data.responseMsg);
                        setLoaderOption(false);
                        setDisableSaveBtn(false);
                        openPopup(response.data.responseMsg, 'error')
                    }
                }
                catch (error) {
                    console.error('Error fetching data:', error);
                    setLoaderOption(false);
                    setDisableSaveBtn(false);
                    openPopup("Requested Data Not Found / 404", 'warn')
                }
                // finally {
                //     setLoaderOption(false);
                // }
            }

        },
    });

    const exportToExcel = async () => {
        setLoaderOption(true);
        if (authUser.headers && Object.keys(authUser.headers).length > 0 && data.length != 0) {
            // console.log( `${getNewCurrentCallBoardStatusAPIURL}?userUUID=${authUser.headers.userUUID}&callType=${formik.values.callType}&isPagination=0&pageNo=0&perPageRec=0`)
            try {
                const response = await axios.get(
                    `${getHistoricalCallBoardsRecordsAPIURL}?userUUID=${authUser.headers.userUUID}&callType=${formik.values.callType}&isPagination=0&pageNo=0&perPageRec=0&historicDate=${formik.values.selectedDate}`,
                    {
                        headers: { ...authUser.headers },
                        'Authorization': `Bearer ${authUser.headers.access_token}`
                    }
                );

                if (response.data.responseMsg == "Success") {
                    const rawData = response.data.data.items; // API response data

                    // Exclude "Action" column
                    const filteredColumns = columns.filter(col => col.header != "Action");

                    // Define headers for Excel
                    const columnHeaders = filteredColumns.map(col => col.header);

                    // Map and transform data based on column definitions
                    const formattedData = rawData.map(item =>
                        filteredColumns.map(col => {
                            const value = item[col.accessorKey] ?? "";

                            // Apply column-specific formatting
                            switch (col.accessorKey) {
                                case "callStatus":
                                    return value == 1 ? "Attended" : "Unattended";
                                default:
                                    return value;
                            }
                        })
                    );

                    // Combine headers and data
                    const sheetData = [columnHeaders, ...formattedData];

                    // Create worksheet and workbook
                    const ws = XLSX.utils.aoa_to_sheet(sheetData);
                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Historic Call Board Records");

                    // Get the current date and time in IST
                    const currentDate = new Date().toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
                    const formattedDate = currentDate.replace(",", "").replace(/\//g, "-").replace(/:/g, "-").split(" ")[0] + " " + currentDate.split(" ")[1];

                    // Set the file name dynamically
                    const fileName = `${submittedCallType}-${formattedDate}.xlsx`;

                    // Export the Excel file
                    XLSX.writeFile(wb, fileName);

                    setLoaderOption(false);
                } else {
                    console.error("API Response Error:", response.data.responseMsg);
                    setLoaderOption(false);
                    openPopup(response.data.responseMsg, "error");
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                setLoaderOption(false);
                openPopup("Requested Data Not Found / 404", 'warn')
            }
        }
    };

    if (!canRead) {
        return (
            <>
                <React.Fragment>
                    <div className="page-content">
                        <Container fluid>
                            <Breadcrumbs title="Report" breadcrumbItem="Current Call Board Status" />
                            <CantAccessPage />
                        </Container>
                    </div>
                </React.Fragment>
            </>
        )
    }
    else {
        if (loaderOption == true) {
            return (
                <>
                    <Loader />
                </>
            )
        }
        else {
            return (
                <React.Fragment>
                    <div className="page-content">
                        <Container fluid>
                            <Breadcrumbs title="Report" breadcrumbItem="Historical Call Board" />
                            <Card>
                                <CardBody>

                                    <Form onSubmit={formik.handleSubmit}>

                                        <Row className="align-items-end g-3">
                                            {/* <Col md={4}> */}
                                            <Col md={3} sm={6} xs={12}>
                                                <FormGroup>
                                                    <Label for="callType">Call Type</Label>
                                                    <Input
                                                        type="select"
                                                        name="callType"
                                                        id="callType"
                                                        className="form-control form-control-sm"
                                                        onChange={(e) => {
                                                            formik.handleChange(e);
                                                            setData([]); // Reset the data when the call type changes
                                                            setPageSize(50);
                                                        }}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.callType}
                                                    >
                                                        <option value="">Select Call Type</option>
                                                        {/* <option value={0}>All</option> */}
                                                        <option value={1}>Live</option>
                                                        <option value={2}>System</option>
                                                        <option value={3}>Cold</option>
                                                    </Input>
                                                    {formik.touched.callType && formik.errors.callType ? (
                                                        <div style={{ color: 'red', marginTop: '5px' }}>
                                                            {formik.errors.callType}
                                                        </div>
                                                    ) : null}
                                                </FormGroup>
                                            </Col>
                                        

                                        {/* <Col md={4}> */}
                                        <Col md={3} sm={6} xs={12}>
                                            <FormGroup>
                                                <Label for="selectedDate">Select Date</Label>
                                                <Input
                                                    type="date"
                                                    name="selectedDate"
                                                    id="selectedDate"
                                                    className="form-control form-control-xs"
                                                    onChange={(e) => {
                                                            formik.handleChange(e);
                                                            setData([]); // Reset the data when the call type changes
                                                            //setPageSize(50);
                                                        }}
                                                    // onChange={formik.handleChange
                                                    // }
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.selectedDate}
                                                    min={minDateFormatted}
                                                    max={maxDateFormatted}
                                                />
                                                {formik.touched.selectedDate && formik.errors.selectedDate ? (
                                                    <div style={{ color: 'red', marginTop: '5px' }}>
                                                        {formik.errors.selectedDate}
                                                    </div>
                                                ) : null}
                                            </FormGroup>
                                        </Col>  
                                        </Row>          
                                          <Col md={2} sm={6} xs={12}>   
                                            <Button color="primary" type="submit" size="xs"  disabled={disabelSaveBtn || !canRead}>
                                                Submit
                                            </Button>
                                         </Col>
                                        
                                    </Form>

                                    {(data.length != 0)
                                        ?
                                        <>

                                            {/* <h5 className="mt-4" style={{ color: '#b72323' }}>
                                                Report for : Current {submittedCallType} Call Status
                                            </h5> */}
                                             <div className="mt-4"></div>

                                            {/* <div className="mb-4">
                                                 <Row className="align-items-center"></Row>
                                                <h5 style={{ color: '#b72323', fontWeight: 600 }}>
                                                    Report for : {submittedCallType} Call Status
                                                </h5>
                                                <div style={{ fontSize: "14px", color: "#6c757d" }}>
                                                    Date : {formik.values.selectedDate}
                                                </div>
                                            </div> */}

                                            <div className="mt-4">

                                                <Row className="align-items-center">

                                                    {/* Report Heading */}
                                                    <Col md={8} sm={8} xs={12}>
                                                    <div>
                                                        <h5 style={{ color: '#b72323', fontWeight: 600 }}>
                                                        Report for : {submittedCallType} Call Board
                                                        </h5>
                                                         <hr className="my-3" />
                                                        <div style={{ fontSize: "14px", color: "#6c757d" }}>
                                                        Date : {formik.values.selectedDate}
                                                        </div>
                                                    </div>
                                                   
                                                    </Col>

                                                    {/* Export Button */}
                                                    <Col md={4} sm={4} xs={12} className="text-md-end mt-3 mt-md-0">
                                                    <button
                                                        color="success"
                                                        size="sm"
                                                        onClick={exportToExcel}
                                                        className="btn btn-primary me-1"
                                                    >
                                                        Export Excel
                                                    </button>
                                                    </Col>

                                                </Row>

                                            </div>


                                            <div className='mt-3'>
                                                {/* <div className="d-flex align-items-center justify-content-end mb-2">
                                                    <div className="flex-shrink-0">
                                                        <button
                                                            onClick={exportToExcel}  // Trigger the export function
                                                            className="btn btn-primary me-1"
                                                        >
                                                            Export Excel
                                                        </button>
                                                    </div>
                                                </div> */}
                                                <TableContainer
                                                    columns={columns}
                                                    data={data || []}
                                                    isGlobalFilter={true}
                                                    isPagination={true}
                                                    SearchPlaceholder="Search..."
                                                    isCustomPageSize={true}
                                                    tableClass="align-middle table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                                    theadClass="table-light"
                                                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                                    pagination="pagination"
                                                    getRowProps={row => ({
                                                        className: `${row.original.callStatus == 0 ? "is-receivable" : ""
                                                            }`,
                                                    })}
                                                    onPageChange={handlePageChange} // Pass page change handler
                                                    onPageSizeChange={handlePageChange} // Pass page size change handler
                                                    pageSize={pageSize}
                                                    setPageSize={setPageSize}
                                                    totalPages={totalPages}
                                                    totalItems={totalItems}
                                                    tableNextPage={nextPage}
                                                    tablePreviousPage={previousPage}
                                                    tableCurrentPage={currentPage}
                                                    customePageSize={customePageSize}
                                                />
                                            </div>
                                        </>
                                        :
                                        ''
                                    }



                                </CardBody>
                            </Card>
                        </Container>
                    </div>

                    {isPopupVisible && (
                        <PopupWindow message={popupMessage} type={popupType} onClose={closePopup} />
                    )}
                </React.Fragment >
            );
        }
    }
};

HistoricCallBoard.propTypes = {
    t: PropTypes.any,
};

export default withTranslation()(HistoricCallBoard);

